import * as React from "react";

const ArrowThreeIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="33">
    <path
      fill="#D3E205"
      d="m16 32 2.84-2.84L5.68 16 18.84 2.84 16 0 0 16z"
    ></path>
  </svg>
);

export default ArrowThreeIconSVG;


